import React, { useContext, useEffect, useState } from 'react'
// import useSound from 'use-sound';
import  format  from 'date-format';

import { Sliders } from '../components/carousel';

import { useHideMenu } from '../hooks/useHideMenu';
import { SocketContext } from '../context/SocketContext';
import { UseSweetAlert } from '../hooks/useSweetAlert';
import { getUltimos } from '../helpers/getUltimos';

import sound from "../assets/new-ticket.mp3";
import mascota from "../assets/mascota.png";

let entidad= localStorage.getItem('entidad') || null;

export const Cola = () => {

    useHideMenu(true);

    const { socket } = useContext( SocketContext );
    const [tickets, setTickets] = useState([]);
    // const [pendientes, setPendientes] = useState([]);
    const [entidadBD, setEntidadBD] = useState(null);
    const [playAnimation] = useState(false);


    useEffect(() => {
        
        async function fetchData() {
            await socket.on('ticket-asignado', ( asignados )=> {
                const audio =  new Audio(sound);
                audio.play();
                
                setTickets( asignados )
                
            })
            
          }
        fetchData();

        
        
        return () => {
            socket.off('ticket-asignado')
        }
    }, [socket])

    
    useEffect(() => {

        // entidad= localStorage.getItem('entidad') || null;
        // if(entidad=== null) location.reload(); 
        
        // await getUltimos().then( tickets => setTickets(tickets) )
        const getUsers = async () => {
            const tickets = await getUltimos();
            setTickets(tickets);
            
        };
    
        getUsers(); 
      
      
    }, [])

    const ingresar = () =>{

        let entidadB = document.getElementById('codigoEntidad');
        let codigoEntidad= entidadB.value;
        if(codigoEntidad === "") return UseSweetAlert("Atención!", 'Falta información', 'error');

        socket.emit('registro-entidad', { codigoEntidad },  async( respuesta ) => {
            if(respuesta.length === 0) return UseSweetAlert("Atención!", "Revise la información", "error");
            setEntidadBD( respuesta[0].codigoEntidad );
            localStorage.setItem('entidad', entidadBD.codigoEntidad);
            entidad= entidadBD.codigoEntidad;

            const tickets = await getUltimos();
            setTickets(tickets);
        
        })
    }    

    
    
   
    

    return (
        <>
            {
                entidad !== null ? 
                (
                    <div className='row'>
                       
                        <div className="row">
                            <div className="col-lg-5 col-sm-5 col-12 list-group">
                                <div className='row'>
                                    <Sliders />

                                </div>

                                <div className='d-grid gap-2 mt-3'>
                                <div className="card text-info bg-light mb-3 shadow" width="100%">
                                    {/* <div className="card-header">Header</div> */}
                                    <div className="card-body">
                                        <div className='row'>
                                            
                                            <div className='col-4'>
                                                <img className="mt-5" style={{height:'auto',width:'70%'}} src={ mascota } alt=''/>
                                            </div>

                                            <div className='col-8'>
                                                <h5 className="card-title">RECUERDA</h5>
                                            
                                                <p className="card-text p-2 shadow">
                                                    
                                                    1. Alista los siguientes documentos para agilizar tu atención en admisión y registro:
                                                    Documento de Identificación del Paciente
                                                    Autorización y/o Orden Médica
                                                    Historia Clínica
                                                    Dinero: Cuota Moderado - Copago - Atención Particular
                                                </p>
                                                
                                                <p className="card-text p-2 shadow">

                                                    2. Entrega los siguientes documentos para mejorar tu atención con el profesional en salud:
                                                    Historia Clínica
                                                    Resultados de exámenes o laboratorios anteriores
                                                    Nombre de los medicamentos y/o tratamientos

                                                </p>

                                            </div>
                                            
                                        </div>
                                    </div>
                                    </div>
                                </div>

                            </div>


                            <div className="col-lg-3 col-sm-4 col-12 list-group" style={{fontSize:"12px"}}>
                                
                                { 

                                    tickets.slice(0,3).map( (ticket, index) =>{
                                        
                                        if (index === 0){

                                            return(
                                                <div className= {`card border-3 border-danger shadow mb-2 parpadea ${{ myAnimation: playAnimation }}`} key={index} >
                                        
                                                    <div className='card-body mx-sm-1 p-3 justify-content-center'>

                                                        <div className="text-danger text-center mt-1 col-12"> <h3> <b>{ ticket.codigoTipoAtencion}-{ticket.numeroTicket} </b> </h3> </div>
                                                        
                                                        {   ticket.nombrePaciente !=="    " && (
                                                            <div className="text-danger text-center mt-1 col-12"> <h5>{ticket.nombrePaciente}</h5> </div>
                                                            
                                                        )}

                                                    </div>


                                                    <div className='card-footer mx-sm-1 p-3 d-flex align-items-center justify-content-center'>
                                                        <div className="text-danger text-center mt-1"> <h4> Módulo { ticket.modulo}</h4> </div>

                                                    </div>

                
                                                </div>
                                            )

                                        }else {
                                            return(
                                                <div className= "card border-secondary shadow mb-2" key={index}>
                                        
                                                    <div className='card-body mx-sm-1 p-3 justify-content-center'>

                                                        <div className="text-secondary text-center mt-1 col-12"> <h3> <b>{ ticket.codigoTipoAtencion}-{ticket.numeroTicket}</b></h3> </div>
                                                        
                                                        {   ticket.nombrePaciente !=="    " && (
                                                            <div className="text-secondary text-center mt-1 col-12"> <h5>{ticket.nombrePaciente}</h5> </div>
                                                            
                                                        )}

                                                    </div>

                                                    <div className='card-footer mx-sm-1 p-3 d-flex align-items-center justify-content-center'>

                                                        <div className="text-secondary text-center mt-1"> <h4> Módulo { ticket.modulo}</h4> </div>
                                                        
                                                    </div>

                                                    
                
                                                </div>
                                            )
                                        }
                                    })
                                
                                
                                }
                                
                            </div>

                            <ul className="col-lg-4 col-sm-4 col-12 list-group list-group-flush" style={{fontSize:"12px"}}>
                                { 
                                    tickets.slice(3).map( (ticket, index) =>{
                                            const date= format('hh:mm:ss', new Date(ticket.atendidoEn));
                                            return(
                                                // <li className="list-group-item d-flex w-100 justify-content-between" key={index}>
                                                <li className="list-group-item d-flex w-100 justify-content-between mb-1 shadow" key={index}>
                                                    <h4> Turno { ticket.codigoTipoAtencion}-{ticket.numeroTicket} </h4> <h5> <span className='text-success'>  Módulo {ticket.modulo}</span></h5> <h6>llamado: { date }</h6>
                                                </li>

                                            )
                                        
                                    
                                    })
                                
                                
                                }
                                
                            </ul>
                        </div>
                    </div>

                ): (
                    <div className="row">
                    
                        <div className="d-flex justify-content-center mb-5">
                            <div className='d-grid gap-2 col-lg-3 col-12 mx-auto'>
                                
                                <div className='col-12'>
                                    <label htmlFor="codigoEntidad">Código Entidad</label>
                                    <input 
                                        type='text'
                                        id= 'codigoEntidad' 
                                        className='shadow form-control '
                                        autoComplete='off' 
                                        style={{ fontSize: 2+'em', textShadow: '2px 2px 8px #B8FFE9'}}
                                    /> 

                                </div>

                                <div className='d-grid gap-2'>
                                    <button className="btn btn-success btn-lg btn-block shadow" type="button" onClick={ () => ingresar()} >INGRESO</button>
                                </div>

                                
                            </div>
                        </div>
              

                    </div>
                    
                )

            }
        </>
    )
}
